import React, { useState }                      from 'react'
import {
   Box,
   Button,
   Grid,
   TextField,
   Typography }                                 from '@material-ui/core'
import PropTypes                                from 'prop-types'

const PilotCohortSourceInputComponent = ( { changeCohort, changePilotName, changeSource, singleEntry } ) => {

   return(
      <Grid container justifyContent='center' style={{marginTop: '1rem'}} >
         <Grid item xs={12} >
            <TextField name='pilot-cohort-source-table-name' label="Pilot Name" variant='outlined' style={{ width: '90%' }} onChange={changePilotName} value={singleEntry.pilotName} autoFocus={true} />
         </Grid>
         <Grid item xs={12} style={{marginTop: '1rem'}} >
            <TextField name='pilot-cohort-source-table-cohort' label="Cohort" variant='outlined' style={{ width: '90%' }} onChange={changeCohort} value={singleEntry.cohort} />
         </Grid>
         <Grid item xs={12} style={{marginTop: '1rem'}} >
            <TextField name='pilot-cohort-source-table-source' label="Source" variant='outlined' style={{ width: '90%' }} onChange={changeSource} value={singleEntry.source} />
         </Grid>
      </Grid>
   )
}

PilotCohortSourceInputComponent.propTypes = {
   changeCohort:                                PropTypes.func,
   changePilotName:                             PropTypes.func,
   changeSource:                                PropTypes.func,
   singleEntry:                                 PropTypes.object
}

export default PilotCohortSourceInputComponent